import React, { useState, useEffect } from 'react'
const goToTrainPage = () => { }

const Locomotive = ({ name }) => (
    <li className="new-fleet-info__train__cars--list__item" >
        <div
            className="new-fleet-info__train__cars--list__item--rect fleet-health__train__cars--list__item--rect__notification">
            <span className="new-fleet-info__train__cars--list__item--rect__title">{name}</span>
        </div>
        <div className="new-fleet-info__train__cars--list__item__wheel-one"></div>
        <div className="new-fleet-info__train__cars--list__item__wheel-two"></div>
        <div className="new-fleet-info__train__cars--list__item__wheel-three"></div>
        <div className="new-fleet-info__train__cars--list__item__wheel-four"></div>
    </li>
)
export default Locomotive